import CommissionIcon from "@assets/svg/CommissionIcon";
// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
// @ts-ignore
import EyeIcon from "@assets/svg/EyeIcon";
import EditIcon from "@assets/svg/EditIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import TickThinOutline from "@assets/svg/TickThinOutline";
import { Briefcase, Calendar1 } from "lucide-react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { getActivityTracker } from "@endpoints/activityTracker/activityTracker.service";
import { EnumActivityTracker } from "@utils/constants";
import { IActivityTracker } from "@endpoints/types/activityTracker.type";
import MailOpenIcon from "@assets/svg/MailOpenIcon";
import ArrowAboveIcon from "@assets/svg/ArrowAboveIcon";
import BookmarkIcon from "@assets/svg/BookmarkIcon";
import SkeletonTrackerList from "./components/SkeletonTrackerList";
import TrackIcon from "@assets/svg/TrackIcon";

const BoldText = ({ children }) => {
  return <span className="font-semibold text-gray-500">{children}</span>;
};
const BaseText = ({ children }) => {
  return <span className="font-semibold text-gray-500">{children}</span>;
};

function getIcon(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return <Briefcase className={"w-5 h-5"} stroke="#2e2e2e" />;
    case EnumActivityTracker.OFFER_RECEIVED:
      return <MailOpenIcon className={"w-6 h-6"} fill={"#2e2e2e"} />;
    case EnumActivityTracker.INTERVIEW_INVITE_SENT:
      return <Calendar1 size={20} stroke={"#2e2e2e"} />;
    case EnumActivityTracker.MEETING_FORWARDED:
      return <Calendar1 size={20} stroke={"#2e2e2e"} />;
    case EnumActivityTracker.SHORTLIST_BY_RECRUITER_AGENCY:
      return <BookmarkIcon className={"w-6 h-6"} fill={"#2e2e2e"} />;
    case EnumActivityTracker.CANDIDATE_SHORTLISTED:
      return <BookmarkIcon className={"w-6 h-6"} fill={"#2e2e2e"} />;
    case EnumActivityTracker.APPLICATION_SUBMITTED:
      return <ArrowAboveIcon className={"w-5 h-5"} fill="#4d4d4d" />;
    // return <CommissionIcon className={"w-5 h-5"} fill={"#2e2e2e"} />;
    case EnumActivityTracker.APPLICATION_VIEWED:
      return <EyeIcon className={"w-5 h-5"} fill={"#2e2e2e"} />;
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return (
        <TickThinOutline
          className={"w-5 h-5 border rounded-full border-gray-500"}
          fill={"#2e2e2e"}
        />
      );
    case EnumActivityTracker.PROFILE_UPDATED:
      return <EditIcon className={"w-5 h-5"} fill={"gray"} />;
    case EnumActivityTracker.USER_REGISTERED:
      return <ProfileIcon className={"w-4 h-4"} fill={"gray"} />;
    default:
      return <CommissionIcon className={"w-4 h-4"} fill={"gray"} />;
  }
}
function getTitle(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return "Successful placement";
    case EnumActivityTracker.OFFER_RECEIVED:
      return "Offer Received";
    case EnumActivityTracker.INTERVIEW_INVITE_SENT:
      return "Interview Invitation";
    case EnumActivityTracker.MEETING_FORWARDED:
      return "Availability Poll";
    case EnumActivityTracker.CANDIDATE_SHORTLISTED:
      return "Shortlisted";
    case EnumActivityTracker.SHORTLIST_BY_RECRUITER_AGENCY:
      return "Shortlisted";
    case EnumActivityTracker.APPLICATION_SUBMITTED:
      return "Application Submitted";
    case EnumActivityTracker.APPLICATION_VIEWED:
      return "Application Viewed";
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return "Applied";
    case EnumActivityTracker.PROFILE_UPDATED:
      return "Profile Edit";
    case EnumActivityTracker.USER_REGISTERED:
      return "Registration";
    default:
      return "Default";
  }
}

function getDescImage(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.OFFER_RECEIVED:
      return data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.INTERVIEW_INVITE_SENT:
      return data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.MEETING_FORWARDED:
      return data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.CANDIDATE_SHORTLISTED:
      return data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.SHORTLIST_BY_RECRUITER_AGENCY:
      return !data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.companyName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.APPLICATION_SUBMITTED:
      return data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.APPLICATION_VIEWED:
      return data?.recruiterAgencyId?.profilePic ? (
        <img
          src={data?.recruiterAgencyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.recruiterAgencyId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return data?.createdBy?.profilePic ? (
        <img
          src={data?.createdBy?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.createdBy?.firstName?.charAt(0)}
        </div>
      );
    default:
      return <img src={ProfileImg} className="w-6 h-6 rounded-full" />;
  }
}

function getDescription(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You</BoldText>
          <span>have been successfully placed at</span>
          <BoldText>Google Inc</BoldText>
          <span>regarding position title</span>
          <BoldText>ABC Recruitment.</BoldText>
        </span>
      );
    case EnumActivityTracker.OFFER_RECEIVED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName} </BoldText>
          sent you an offer from{" "}
          <BoldText>{data?.hiringCompanyId?.companyName} </BoldText>
          regarding
          <BoldText>{data?.jobId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.INTERVIEW_INVITE_SENT:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>ABC Recruitment </BoldText>
          has sent you an <BoldText>interview invitation </BoldText>
          for
          <BoldText>11am Monday 20th October 2025.</BoldText>
        </span>
      );
    case EnumActivityTracker.MEETING_FORWARDED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName} </BoldText>
          has sent you an <BoldText>availability poll. </BoldText>
        </span>
      );
    case EnumActivityTracker.CANDIDATE_SHORTLISTED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>Google Inc </BoldText>
          has shortlisted your application for the position
          <BoldText>React Frontend Developer.</BoldText>
        </span>
      );
    case EnumActivityTracker.SHORTLIST_BY_RECRUITER_AGENCY:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName}</BoldText>
          has shortlisted your application for the position
          <BoldText>{data?.jobId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.APPLICATION_SUBMITTED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName}</BoldText>
          has submitted your application to
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
          for the position titled <BoldText>{data?.jobId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.APPLICATION_VIEWED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName} </BoldText>
          has viewed your application for the position
          <BoldText>{data?.jobId?.title}. </BoldText>
        </span>
      );
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You </BoldText>
          applied for the job post
          <BoldText>{data?.jobId?.title} </BoldText>
          submitted by
          <BoldText>{data?.recruiterAgencyId?.companyName}.</BoldText>
        </span>
      );
    case EnumActivityTracker.PROFILE_UPDATED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You </BoldText>
          successfully updated your skills.
        </span>
      );
    case EnumActivityTracker.USER_REGISTERED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You </BoldText>
          registered successfully on COMTRACKED.
        </span>
      );
    default:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>ABC Recruitment </BoldText>
          sent you an offer from <BoldText>ABC Recruitment </BoldText>
          regarding
          <BoldText>ABC Recruitment.</BoldText>
        </span>
      );
  }
}

type CardProps = {
  type: EnumActivityTracker;
  data: IActivityTracker;
};

const Card = ({ type, data }: CardProps) => {
  return (
    <div className="flex gap-5">
      <div className="flex items-center justify-center w-12 h-12 rounded-md bg-gray-100">
        {getIcon(type, data)}
      </div>
      <div className="flex flex-col gap-1 w-full">
        <span className="font-semibold text-xs gap-5 flex text-primary">
          {getTitle(type, data)}
          <span className="font-medium text-light-black">
            {dayjs(data?.createdAt).format("hh:mm a, dddd DD MMM")}
          </span>
        </span>
        <div className="flex text-xs text-primary bg-[#fafafa] w-full rounded-md p-3 gap-3">
          {getDescImage(type, data)}
          <div className="mt-[0.2rem]">
          {getDescription(type, data)}
          </div>
        </div>
      </div>
    </div>
  );
};

const TrackerPage = () => {
  const [acitvities, setAcitvities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchActivityTracker = async () => {
    try {
      setIsLoading(true);
      const { data, success } = await getActivityTracker();
      if (success && data) {
        setAcitvities(data?.data);
      }
    } catch (error) {
      console.error("Error: fetching activity trackers", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActivityTracker();
  }, []);

  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-md bg-white p-5">
      <span className="font-bold text-primary mx-auto">Activity Tracker</span>

      {/* Tracker List */}
      <div className="flex flex-col min-h-0 mb-5 mt-8 w-[60%] mx-auto gap-6 overflow-y-scroll no-scrollbar">
        {isLoading ? (
          <SkeletonTrackerList />
        ) : acitvities?.length ? (
          acitvities?.map((activity) => {
            return <Card type={activity?.eventType} data={activity} />;
          })
        ) : (
          <div className="flex-col gap-3 m-auto h-[90vh] flex justify-center items-center font-medium text-light-black text-sm">
            <TrackIcon className={"w-16 h-16"} fill={"gray"} />
            No acitvities recorded till now.
          </div>
        )}
        {/* <Card type="offer" />
        <Card type="invitation" />
        <Card type="poll" />
        <Card type="shortlist" />
        <Card type="submit" />
        <Card type="view" />
        <Card type="applied" />
        <Card type="edit" />
        <Card type="register" /> */}
      </div>
    </div>
  );
};

export default TrackerPage;
